<template>
    <div class="">
        {{ $tc('messages.X_students_selected', studentIds.length, { number: studentIds.length }) }}

        <div class="sm:col-span-4">
            <label for="search_student" class="block text-sm font-medium leading-5 text-gray-700"></label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input
                    id="search_student"
                    v-model="search"
                    type="text"
                    :placeholder="$t('messages.show_only')"
                    class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                />
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fill-rule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>

        <div v-for="group in groups" class="mt-3" :key="group.id">
            <StudentBatchSelectorGroup
                :group="group"
                v-model="studentIds"
                :collapsed="collapsed.includes(group.id)"
                :search="search"
                @toggle-group="toggleGroup(group)"
            />
        </div>
    </div>
</template>

<script>
import StudentBatchSelectorGroup from '@/components/pageSpecific/StudentBatchSelectorGroup.vue';

export default {
    components: {
        StudentBatchSelectorGroup,
    },
};
</script>

<script setup>
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';
let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Array,
        required: false,
        default: () => [],
    },
    groups: {
        type: Array,
        required: true,
    },
});

const studentIds = useVModel(props, 'modelValue', emit);

const search = ref('');
const collapsed = ref([]);
const toggleGroup = (group) => {
    if (collapsed.value.includes(group.id)) {
        collapsed.value.splice(collapsed.value.indexOf(group.id), 1);
    } else {
        collapsed.value.push(group.id);
    }
};
</script>
